import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Zap, Menu, X, ArrowUpRight } from "lucide-react";
import ThemeToggle from "./ThemeToggle";
import { whatsappUrl, trackWaClick } from "../lib/whatsapp";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  const navItems = [
    { label: "Vorteile", href: "#vorteile" },
    { label: "Ablauf", href: "#ablauf" },
    { label: "Kontakt", href: "#kontakt" },
  ];

  const trackCTA = () => trackWaClick("header");

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "glass-header border-b border-brand-line" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`flex items-center justify-between transition-all duration-300 ${scrolled ? "h-12" : "h-14"}`}>
          <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
            <div className="relative w-7 h-7 rounded-lg bg-brand-inverse flex items-center justify-center overflow-hidden">
              <Zap className="w-3.5 h-3.5 relative z-10" style={{ color: 'var(--brand-green-neon)' }} strokeWidth={2.5} />
              <span aria-hidden className="absolute inset-0 bg-brand-energy opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
            <span className="font-heading text-sm sm:text-base font-bold tracking-tight text-brand-ink">
              Strombaron
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-7">
            {navItems.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="link-underline text-[13px] font-medium text-brand-muted hover:text-brand-ink transition-colors"
                data-testid={`nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <ThemeToggle />
            <a
              href={whatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackCTA}
              className="rounded-full px-4 py-2 text-[13px] font-semibold inline-flex items-center gap-1.5 text-white shadow-[0_8px_20px_-6px_rgba(0,200,83,0.5)] hover:shadow-[0_12px_28px_-6px_rgba(0,200,83,0.6)] hover:-translate-y-0.5 transition-all"
              style={{ background: 'linear-gradient(135deg, #00C853 0%, #00E676 100%)' }}
              data-testid="header-cta"
            >
              Per WhatsApp starten
              <ArrowUpRight className="w-3.5 h-3.5 arrow-shift" strokeWidth={2.4} />
            </a>
          </div>

          <div className="md:hidden flex items-center gap-1.5">
            <ThemeToggle />
            <button
              className="p-2 rounded-lg hover:bg-brand-offwhite transition"
              onClick={() => setOpen(!open)}
              data-testid="mobile-menu-toggle"
              aria-label="Menü"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden pb-4 space-y-1 border-t border-brand-line mt-1" data-testid="mobile-menu">
            {navItems.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="block px-3 py-3 rounded-xl text-brand-ink hover:bg-brand-offwhite text-sm font-medium"
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </a>
            ))}
            <a
              href={whatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => { setOpen(false); trackCTA(); }}
              className="block rounded-full px-5 py-3 text-center font-semibold text-sm mt-2 text-white shadow-[0_10px_24px_-6px_rgba(0,200,83,0.5)]"
              style={{ background: 'linear-gradient(135deg, #00C853 0%, #00E676 100%)' }}
              data-testid="mobile-cta"
            >
              Per WhatsApp starten
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
